import { useEffect } from "react";

import { useAuth, useHookForm, useMerchantApiMutation } from "../../../hooks";
import {
  IHookForm,
  IModalFormProps,
  IAddNewBusinessRequest,
  IStaffDepartment,
} from "../../../interfaces-and-types";
import { globalHandlerUtils } from "../../../utils";

import { View } from "./View";
import { addNewBusinessSchema } from "./validationSchema";

export interface IAddNewBusinessFormViewProps
  extends IHookForm<IAddNewBusinessRequest>,
    IModalFormProps {
  formValues: IAddNewBusinessRequest;
  activeMerchantName: string;
}

export const AddNewBusinessForm = (props: IModalFormProps) => {
  const { setStaffDepartments, staff_departments, active_tenant_id } =
    useAuth();

  const activeMerchantProfile = staff_departments.find(
    (d) => d.merchant_id === active_tenant_id
  );

  const activeMerchantName = activeMerchantProfile?.merchant_name || "";

  const {
    isSuccess: isSuccessAddNewBusiness,
    data: userMerchantAccountStaffDeptResponse,
    mutate: addNewBusiness,
  } = useMerchantApiMutation<IAddNewBusinessRequest, IStaffDepartment[]>(
    "addNewBusiness"
  ).usePostMutation;

  useEffect(() => {
    if (isSuccessAddNewBusiness) {
      // set the new staff departments in the header
      setStaffDepartments(userMerchantAccountStaffDeptResponse.data);

      props.closeModal();
      reset();
    }
  }, [isSuccessAddNewBusiness]);

  const initialFormValues: IAddNewBusinessRequest = {
    merchant_name: "",
    business_email_address: "",
    country: activeMerchantProfile?.merchant_country ?? "NG",
    phone_number: undefined,
    bvn: undefined,
    nin: undefined,
    copy_settings_from_main_account: true,
    link_account_verification_with_main_account: true,
  };

  const handleApiSubmit = (data: IAddNewBusinessRequest) => {
    addNewBusiness(data);
  };

  const handleError = (errors: any) => globalHandlerUtils.handleError(errors);

  const { onFormSubmit, errors, register, reset, watch } = useHookForm({
    initialFormValues,
    validationSchema: addNewBusinessSchema,
    onValid: handleApiSubmit,
    onInvalid: handleError,
  });

  const formValues = watch();

  return (
    <View
      {...props}
      activeMerchantName={activeMerchantName}
      isModalOpen={props.isModalOpen}
      closeModal={props.closeModal}
      formValues={formValues}
      handleSubmit={onFormSubmit}
      register={register}
      errors={errors}
    />
  );
};
